<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<img alt="Image" src="Book1/images/Baum-LostPrincess-scan007.jpg"/>
</div>
<h2 class="chapter">To My Readers</h2>
<p class="noindent">Some of my youthful readers are developing wonderful imaginations. This pleases me. Imagination has brought mankind through the Dark Ages to its present state of civilization. Imagination led Columbus to discover America. Imagination led Franklin to discover electricity. Imagination has given us the steam engine, the telephone, the talking-machine and the automobile, for these things had to be dreamed of before they became realities. So I believe that dreams—day dreams, you know, with your eyes wide open and your brain-machinery whizzing—are likely to lead to the betterment of the world. The imaginative child will become the imaginative man or woman most apt to create, to invent, and therefore to foster civilization. A prominent educator tells me that fairy tales are of untold value in developing imagination in the young. I believe it.<a id="page_iv"></a></p><a id="page_iv">
<p class="indent">Among the letters I receive from children are many containing suggestions of “what to write about in the next Oz Book.” Some of the ideas advanced are mighty interesting, while others are too extravagant to be seriously considered—even in a fairy tale. Yet I like them all, and I must admit that the main idea in “The Lost Princess of Oz” was suggested to me by a sweet little girl of eleven who called to see me and to talk about the Land of Oz. Said she: “I s’pose if Ozma ever got lost, or stolen, ev’rybody in Oz would be dreadful sorry.”</p>
<p class="indent">That was all, but quite enough foundation to build this present story on. If you happen to like the story, give credit to my little friend’s clever hint. And, by the way, don’t hesitate to write me your own hints and suggestions, such as result from your own day dreams. They will be sure to interest me, even if I cannot use them in a story, and the very fact that you have dreamed at all will give me pleasure and do you good. For, after all, dear reader, these stories of Oz are just yours and mine, and we are partners. As long as you care to read them I shall try to write them, and I’ve an idea that the next one will relate some startling adventures of the “Tin Woodman of Oz” and his comrades.</p>
<p class="right">L. F<span class="small">RANK</span> B<span class="small">AUM</span>,</p>
<p class="right1">Royal Historian of Oz.</p>
<p class="noindent">   “OZCOT” </p>
<p class="noindent">at HOLLYWOOD</p>
<p class="noindent">in CALIFORNIA</p>
</a><p class="noindent"><a id="page_iv">    1917.</a><a id="page_v"></a></p><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm2.vue?3a336dec